<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${compTypeId ? 'Edit' : 'Add New'} Component Type`" />
    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="compTypeId" class="custom-label">ID</label>
            <input id="compTypeId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <!-- <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Type</label>
              <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect" v-model.number="saveData.type">
                <option v-for="type in types" :key="type.code" :value="type.code">{{ type.type }}</option>
              </select>
            </div>
          </div> -->
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label class="custom-label">Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model.number="saveData.type">
              <option v-for="type in types" :key="type.code" :value="type.code">{{ type.type }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.compTypeId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.compTypeId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.compTypeId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button"
              @click="addCompTypeData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue';
import deleteModal from '@/components/delete-modal.vue';
import { ddType, addCompType, getByCompType, updateCompType } from '@/http/hub-sensors/component-type.http'
export default {
  name: 'component-type-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      breadcrumsfirst: "Hub & Sensors",
      breadcrumslast: "Component Type",
      compTypeId: this.$route.params.id,
      saveData: {},
      types: []
    }
  },
  async mounted() {
    await this.getTypeDropdownData();
    await this.getDetailData();
  },
  methods: {
    addCompTypeData() {
      if (this.compTypeId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateCompType({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/hubsensors/componenttype")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addCompType(this.saveData).then(() => {
          this.$router.push("/hubsensors/componenttype")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    async getTypeDropdownData() {
      try {
        const response = await ddType();
        this.types = response;
        if (this.types.length > 0) {
          if (this.compTypeId) {
            const index = this.types.findIndex(type => type.code === this.saveData.type);
            if (index !== -1) {
              this.saveData.type = this.types[index].code;
            }
          } else {
            this.saveData.type = this.types[0].code;
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async getDetailData() {
      if (this.compTypeId) {
        try {
          const response = await getByCompType(this.compTypeId);
          this.saveData = response;
          this.saveData.type = response.type;
        } catch (error) {
          console.error('Error fetching detail data:', error);
        }
      }
    },
    cancelButton() {
      this.$router.push("/hubsensors/componenttype")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateCompType({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/hubsensors/componenttype")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>